import * as React from 'react';

type StarIconProps = {
  fill: string;
  stroke: string;
} & React.SVGProps<SVGSVGElement>;

const StarIcon: React.FC<StarIconProps> = ({ fill, stroke, ...rest }) => {
  return (
    <svg width="23" height="23" viewBox="0 0 23 23" fill={fill} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4999 1.8999L14.6999 8.2999L21.7999 9.2999L16.6999 14.2999L17.8999 21.3999L11.5999 18.0999L5.2999 21.3999L6.4999 14.2999L1.3999 9.2999L8.4999 8.2999L11.4999 1.8999Z"
        stroke={stroke}
      />
    </svg>
  );
};

export default StarIcon;
